import "@babel/polyfill";
import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import { applyMiddleware, createStore } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { PersistGate } from 'redux-persist/integration/react'
import reducers from './main/Reducers'
import App from './main/App'
import registerServiceWorker from './registerServiceWorker'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

Bugsnag.start({
  apiKey: 'cb1b3d83b973b1a61f4b2494c1637de9',
  plugins: [new BugsnagPluginReact()]
})

const ErrorBoundary = Bugsnag.getPlugin('react')
  .createErrorBoundary(React)

const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['exam']
};

const persistedReducer = persistReducer(persistConfig, reducers);
const store = applyMiddleware(thunk)(createStore)(persistedReducer, devTools);
const persistor = persistStore(store);

ReactDOM.render(
    <ErrorBoundary>
    <AppContainer>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    </AppContainer>
    </ErrorBoundary>,
    document.getElementById('beduka-enem-app')
);

registerServiceWorker();
